export const getHealthIndexStatus = (score, healthyThreshold, criticalThreshold) => {
  if (score >= healthyThreshold) {
    return 'Healthy';
  }
  if (score >= criticalThreshold) {
    return 'At risk';
  }
  return 'Critical';
};

export const getHealthIndexTrend = (
  currentScore,
  historicalHealthIndex,
  trendWindowDays,
  stableThresholdPercent,
  today = new Date()
) => {
  const targetDate = new Date(today.getTime() - trendWindowDays * 86400000);

  const pastPoint = historicalHealthIndex
    .filter(point => new Date(point.date) <= targetDate)
    .sort((a, b) => new Date(b.date) - new Date(a.date))[0];

  if (!pastPoint) {
    return null;
  }

  const pastScore = pastPoint.healthIndex;
  if (pastScore === 0) {
    return currentScore > 0 ? 'Improving' : 'Stable';
  }

  const percentChange = Math.round(((currentScore - pastScore) / pastScore) * 10000) / 100;
  if (percentChange > stableThresholdPercent) {
    return 'Improving';
  }
  if (percentChange < -stableThresholdPercent) {
    return 'Declining';
  }
  return 'Stable';
};

export const getSeverityCode = severityLabel => {
  if (!severityLabel) {
    return null;
  }
  return severityLabel.split(' ')[0];
};

export const getFixImpactLabel = (issue, currentScore) => {
  const impact = issue.fixImpactPercent;
  if (
    (impact > 0 && impact < 1) ||
    (impact === 0 && issue.scoreImpactPercent < 0 && currentScore > 0)
  ) {
    return '<1%';
  }
  return `+${impact}%`;
};

export const getBandDropAlert = (historicalHealthIndex, healthyThreshold, criticalThreshold) => {
  const sorted = [...historicalHealthIndex].sort((a, b) => new Date(a.date) - new Date(b.date));
  if (sorted.length < 2) {
    return null;
  }

  const bandRank = { Healthy: 2, 'At risk': 1, Critical: 0 };
  const bandOf = score => getHealthIndexStatus(score, healthyThreshold, criticalThreshold);

  let drop = null;
  for (let i = 1; i < sorted.length; i++) {
    const prevBand = bandOf(sorted[i - 1].healthIndex);
    const currBand = bandOf(sorted[i].healthIndex);
    if (bandRank[currBand] < bandRank[prevBand]) {
      drop = {
        date: sorted[i].date,
        fromScore: sorted[i - 1].healthIndex,
        toScore: sorted[i].healthIndex,
        band: currBand,
      };
    }
  }

  if (!drop) {
    return null;
  }

  const currentBand = bandOf(sorted[sorted.length - 1].healthIndex);
  if (currentBand !== drop.band) {
    return null;
  }

  return drop;
};

export const getPlainTextSummary = (html, maxLength) => {
  if (!html) {
    return '';
  }

  const withSpacedBlocks = html.replace(/<\/(p|div|li|br)>/gi, '$& ');
  const plainText = withSpacedBlocks
    .replace(/<[^>]*>/g, '')
    .replace(/\s+/g, ' ')
    .trim();

  if (plainText.length <= maxLength) {
    return plainText;
  }

  return plainText.slice(0, maxLength) + '…';
};